import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Colors } from "../Colors/Colors";

function ConfirmSplitEntryDialog({ handleCancel, handleConfirm }) {
  return (
    <Dialog
      title={"Confirm"}
      onClose={handleCancel}
      className="confirm-split-entry-dialog"
    >
      <p style={{ margin: "25px", textAlign: "center", fontSize: 16 }}>
        Are you sure you want to commit this operation?
      </p>
      <DialogActionsBar>
        <Button
          className="k-button"
          name={`btnConfirmSplitDialogNo`}
          style={{ backgroundColor: Colors.secondary }}
          onClick={handleCancel}
        >
          No
        </Button>
        <Button
          className="k-button"
          name={`btnConfirmSplitDialogYes`}
          style={{ backgroundColor: Colors.error }}
          onClick={handleConfirm}
        >
          Yes
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}

export default ConfirmSplitEntryDialog;
